<template>
    <base-container style="height: 100%;">
      <div style="height: 32px; text-align: center;position: absolute;top: 2px;z-index: 100;left: 0;right: 0;">
        <el-radio-group v-model="reserveType" size="small">
          <el-radio-button label="JcMsgRecord">检查预约消息</el-radio-button>
          <el-radio-button label="JyMsgRecord">检验预约消息</el-radio-button>
          <el-radio-button label="ZlMsgRecord">治疗预约消息</el-radio-button>
          <el-radio-button label="BedMsgRecord">床位预约消息</el-radio-button>
          <el-radio-button label="OpMsgRecord">手术预约消息</el-radio-button>
        </el-radio-group>
      </div>
      <transition name="el-zoom-in-center">
        <component :is="reserveType"></component>
      </transition>
    </base-container>
  </template>

  <script>
  import JcMsgRecord from "./jc/MsgRecord.vue";
  import JyMsgRecord from "./jy/MsgRecord.vue";
  import ZlMsgRecord from "./zl/MsgRecord.vue";
  import BedMsgRecord from "./bed/Message.vue";
  import OpMsgRecord from "./op/MsgRecord.vue";
  export default {
    components: { JcMsgRecord, JyMsgRecord,ZlMsgRecord,BedMsgRecord,OpMsgRecord },
    data() {
      return {
        reserveType: "JcMsgRecord",
      };
    },
  };
  </script>

  <style lang="scss" scoped></style>
